<script>
  import { sheetJson } from '$state/data'
  import WordCloudCanvas from '../WordCloud/WordCloudCanvas.svelte'

  let {
    index = 0,
    offset = 0,
    mode = 'cloud',
    activeCategory = null,
    activeWords = null,
  } = $props()

  const circleWords1 = ['Linear', 'Rail', 'Blue']
  const circleWords2 = ['Casa', 'Belvia']
  const priorityWords = new Set([...circleWords1, ...circleWords2])

  const effectiveActiveWords = $derived(
    index >= 5 ? circleWords2 : index === 4 ? circleWords1 : activeWords,
  )
  const effectiveShowCircles = $derived(index >= 4)

  let cloudWidth = $state(0)
  let cloudHeight = $state(0)

  const getYearBin = (yearStr) => {
    const year = parseInt(yearStr, 10)
    if (isNaN(year)) return null
    switch (true) {
      case year <= 2004:
        return '2000–2004'
      case year <= 2009:
        return '2005–2009'
      case year <= 2014:
        return '2010–2014'
      case year <= 2019:
        return '2015–2019'
      case year <= 2024:
        return '2020–2024'
      case year <= 2029:
        return '2025–2029'
      default:
        return '2030–2031'
    }
  }

  const wordCloudData = $derived.by(() => {
    if (!sheetJson || !sheetJson.data) return []

    const wordMap = new Map()
    sheetJson.data.forEach((item) => {
      const word = String(item['descriptive-word'] || '').trim()
      const category = String(item['category'] || '').trim()
      const yearBin = getYearBin(item['year-completed'])

      if (word && word !== '-' && category && yearBin) {
        if (!wordMap.has(word)) {
          wordMap.set(word, { size: 0, category, yearBins: new Set() })
        }
        wordMap.get(word).size += 1
        wordMap.get(word).yearBins.add(yearBin)
      }
    })

    const sorted = Array.from(wordMap.entries())
      .map(([text, { size, category, yearBins }]) => ({
        text,
        size,
        category,
        yearBins: Array.from(yearBins),
      }))
      .sort((a, b) => b.size - a.size)
      .map((item, i) => ({
        ...item,
        color: i < 3 ? 'var(--project-highlight-color, #cfff5e)' : undefined,
      }))

    const top3 = sorted.slice(0, 3)
    const rest = sorted.slice(3)

    // Insert circle words right after the top 3 words so they cluster near the center,
    // but the top 3 words still anchor the dead center (matching the Intro layout perfectly)
    return [
      ...top3,
      ...rest.filter((w) => priorityWords.has(w.text)),
      ...rest.filter((w) => !priorityWords.has(w.text)),
    ]
  })
</script>

<div class="word-cloud-container" bind:clientWidth={cloudWidth} bind:clientHeight={cloudHeight}>
  {#if cloudWidth > 0 && cloudHeight > 0 && wordCloudData.length > 0}
    <div class="cloud-inner" class:visible={index >= 3 && index < 6}>
      <WordCloudCanvas
        words={wordCloudData}
        width={cloudWidth}
        height={cloudHeight}
        {mode}
        {activeCategory}
        activeWords={effectiveActiveWords}
        showCircles={effectiveShowCircles}
        isVisible={index >= 3 && index < 6}
        fadeToCircles={index >= 6}
        circleWords={[...priorityWords]}
        {offset}
        {index}
        entryIndex={3}
      />
    </div>
  {/if}
</div>

<style lang="scss">
  .word-cloud-container {
    position: absolute;
    inset: 0;
  }

  .cloud-inner {
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.6s ease;
    &.visible {
      opacity: 1;
      pointer-events: auto;
    }
  }
</style>
